import { SharedState } from '@trello/shared-state';

export const newUserShowListSpotlightSharedState = new SharedState<boolean>(
  false,
);
